import { useLanguage } from "../../../../../context/LanguageContext";
import { useAdminProductsTranslation } from "../../translations";

// StatusBadge Component
export const StatusBadge = ({ status }) => {
    const { language } = useLanguage();
    const { t } = useAdminProductsTranslation(language);

    const getStatusClass = () => {
        switch (status?.toLowerCase()) {
            case 'active':
                return 'status-active';
            case 'draft':
                return 'status-draft';
            case 'out of stock':
            case 'out-of-stock':
                return 'status-out-of-stock';
            case 'inactive':
                return 'status-inactive';
            default:
                return '';
        }
    };

    const getStatusText = () => {
        switch (status?.toLowerCase()) {
            case 'active':
                return t('active');
            case 'draft':
                return t('draft');
            case 'out of stock':
            case 'out-of-stock':
                return t('outOfStock');
            case 'inactive':
                return t('inactive');
            default:
                return status;
        }
    };

    return <span className={`product-status-badge ${getStatusClass()}`}>{getStatusText()}</span>;
};
// Exporting the component
export default StatusBadge;